module.exports = __webpack_public_path__ + "static/img/215_TO8_2160_og.689ae2b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/215_TO8_2160_og.jpg
// module id = U9Y2
// module chunks = 0